module.exports = __webpack_public_path__ + "img/53-green.dfa03ec7.svg";